import angular from 'angular';
import Logger from '../../../shared/logger';

export const IdentifiersService = (Restangular) => {

    const getIdentifiersCompanySearchAggregate = function (data) {
        return Restangular.all('identifiers')
            .all('searchCompanies')
            .post(data)
            .catch(error => Logger.error(error));
    };

    const searchCompanyByFirstNameParts = function (names) {
        if (Array.isArray(names)) {
            const filteredNames = names.filter(Boolean);
            if (filteredNames.length) {
                return getIdentifiersCompanySearchAggregate({names: filteredNames});
            }
        }
        return [];
    };


    return {
        searchCompanyByFirstNameParts,
    };
};

angular
    .module('TALENYA-FE')
    .factory('IdentifiersService', IdentifiersService);
